/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */


import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Promise from 'bluebird';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withSiteMap } from '@bingads-webui-campaign-react/with-site-map';
import { ProgressiveLoadingBlock } from '@bingads-webui-campaign-react/shell-ui-common';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
// import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { fetchInitData, getPendingImportStatusPromise } from './repository';
import { loadLegacyDeps, createCommonDeps } from './utils';
// todo: facebook style
import { getGoogleImportStyle } from './styles/google-import-page-style';

function initImportPage(props) {
  const {
    perfMarker,
    scope,
    serverContext: { CurrentAccount },
  } = props;
  const { values } = scope || {};
  const {
    importId,
    taskItemId,
    opportunityId,
    source,
    opportunityType,
  } = values || {};
  const currency = CurrentAccount && CurrentAccount.CurrencyCode;

  perfMarker.willFetchData();

  return Promise.all([
    fetchInitData(values, true, true), // todo: handle test token for facebook in repository
    getPendingImportStatusPromise(),
  ]).then(([data, importStatus]) => {
    const deps = {
      ...createCommonDeps({ ...props, data }),
      currency,
      importStatus,
      importId,
      taskItemId,
      uxMode: 'main', // signup mode is not supported so far
      perfMarker,
      dataContextManager,
      opportunityId,
      opportunitySource: source,
      opportunityType,
    };
    return loadLegacyDeps(props).then(spaFactory => spaFactory.initFacebookImportPage(deps));
  });
}

function loadView(props) {
  return React.lazy(() => initImportPage(props)
    .then(view => view.render())
    .then((instance) => {
      instance.startPollingAfterContinueImport();
      return {
        default: () => (<BackboneInstanceWrapper instance={instance} />),
      };
    }));
}

class FacebookImport extends React.PureComponent {
  constructor(props) {
    super();
    // loadView(props);
    this.state = {
      importId: props.scope.values.importId,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.scope.values.importId !== prevState.importId) {
      return {
        importId: nextProps.scope.values.importId,
      };
    }
    return null;
  }

  render() {
    this.FacebookImportPageView = loadView(this.props);
    return (
      <React.Suspense fallback={<ProgressiveLoadingBlock />}>
        <div className={classNames(this.props.classes.pageContainer, this.props.classes.googleImportPage, 'facebook-import-page-container')}>
          <this.FacebookImportPageView />
        </div>
      </React.Suspense>
    );
  }
}

FacebookImport.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.object.isRequired,
    CurrentCustomer: PropTypes.object.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    pageContainer: PropTypes.string.isRequired,
    googleImportPage: PropTypes.string.isRequired, // todo: replace it?
  }).isRequired,
  // perfMarker: perfMarkerPropTypes.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
};

export const StyledFacebookImport = _.compose(
  withI18nConsumer,
  WrappedComponent => withSiteMap(withDefaultStyles(WrappedComponent, getGoogleImportStyle))
)(FacebookImport);
